export default {
    pending: "Oczekujące środki",
    credits: "Zatwierdzone do wypłaty",
    withdrawButton: "Wypłać",
};
